import { render, staticRenderFns } from "./TickerSubmitterDetail.vue?vue&type=template&id=74db47b8&scoped=true&"
import script from "./TickerSubmitterDetail.vue?vue&type=script&lang=js&"
export * from "./TickerSubmitterDetail.vue?vue&type=script&lang=js&"
import style0 from "./TickerSubmitterDetail.vue?vue&type=style&index=0&id=74db47b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74db47b8",
  null
  
)

export default component.exports